package com.vamvisions.main.portfolio.presentation.common

import com.vamvisions.main.portfolio.domain.model.Skill

data class SkillUi(
    val slug: String,
    val name: String,
    val description: String,
    val url: String,
)

fun Skill.toSkillUi(): SkillUi = SkillUi(slug = slug, name = name, description = description, url = url)
